import React from "react";
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";

import PrivateRoute from "./PrivateRoute";
import {
	SessionsLayout,
	AdminLayout,
	ShipperLayout,
} from "../components/Layouts";
import {
	CategoryPage,
	LoginPage,
	CategoriesPage,
	QuestionsPage,
	QuestionPage,
	AdminsPage,
	AdminPage,
	SurveysPage,
	SurveyPage,
	ForgotPasswordPage,
	SurveyScoresPage,
	SurveyScorePage,
	ScoreRulesPage,
	ScoreRulePage,
	MobileVersionsPage,
	ShippersPage,
	GamesPage,
	GamePage,
	GameMessagesPage,
	GameMessagePage,
	RatesPage,
	RatePage,
	RewardsPage,
	RewardPage,
	SpinsPage,
	SpinPage,
	ReportsPage,
	NotificationsPage,
	NotificationPage,
	MaintenancesPage,
	MaintenancePage,
} from "../components/Pages";
import BottomBannersPage from "../components/Pages/BottomBanners";

const index = () => {
	return (
		<Router>
			<Switch>
				<Route path="/login" exact>
					<SessionsLayout>
						<Route exact path="/login" component={LoginPage} />
					</SessionsLayout>
				</Route>
				<Route path="/forgot-password" exact>
					<SessionsLayout>
						<Route
							exact
							path="/forgot-password"
							component={ForgotPasswordPage}
						/>
					</SessionsLayout>
				</Route>
				<PrivateRoute path="/">
					<ShipperLayout>
						<Route exact path="/shipping-labels" component={ShippersPage} />
					</ShipperLayout>
					<AdminLayout>
						<Route
							exact
							path="/survey-categories/:id"
							component={CategoryPage}
						/>
						<Route exact path="/survey-categories" component={CategoriesPage} />
						<Route exact path="/questions/:id" component={QuestionPage} />
						<Route exact path="/questions" component={QuestionsPage} />
						<Route exact path="/admins/:id" component={AdminPage} />
						<Route exact path="/admins" component={AdminsPage} />
						<Route exact path="/surveys/:id" component={SurveyPage} />
						<Route exact path="/surveys" component={SurveysPage} />
						<Route
							exact
							path="/survey-scores/:id"
							component={SurveyScorePage}
						/>
						<Route exact path="/survey-scores" component={SurveyScoresPage} />
						<Route exact path="/score-rules/:id" component={ScoreRulePage} />
						<Route exact path="/score-rules" component={ScoreRulesPage} />
						<Route
							exact
							path="/mobile-versions"
							component={MobileVersionsPage}
						/>
						<Route exact path="/shipping-labels" component={ShippersPage} />
						<Route exact path="/spin-the-wheel/games" component={GamesPage} />
						<Route
							exact
							path="/spin-the-wheel/games/:id"
							component={GamePage}
						/>
						<Route
							exact
							path="/spin-the-wheel/game-messages"
							component={GameMessagesPage}
						/>
						<Route
							exact
							path="/spin-the-wheel/game-messages/:id"
							component={GameMessagePage}
						/>
						<Route exact path="/spin-the-wheel/rates" component={RatesPage} />
						<Route
							exact
							path="/spin-the-wheel/rates/:id"
							component={RatePage}
						/>
						<Route
							exact
							path="/spin-the-wheel/rewards"
							component={RewardsPage}
						/>
						<Route
							exact
							path="/spin-the-wheel/rewards/:id"
							component={RewardPage}
						/>
						<Route
							exact
							path="/spin-the-wheel/overview"
							component={SpinsPage}
						/>
						<Route
							exact
							path="/spin-the-wheel/overview/details/:id"
							component={SpinPage}
						/>
						<Route
							exact
							path="/spin-the-wheel/number-of-spins"
							component={ReportsPage}
						/>
						<Route exact path="/notifications" component={NotificationsPage} />
						<Route
							exact
							path="/notifications/:id"
							component={NotificationPage}
						/>
						<Route exact path="/bottom-banners" component={BottomBannersPage} />
						<Route exact path="/shipping-labels" component={ShippersPage} />
						<Route exact path="/maintenances" component={MaintenancesPage} />
						<Route exact path="/maintenances/:id" component={MaintenancePage} />
					</AdminLayout>
				</PrivateRoute>
			</Switch>
		</Router>
	);
};
export default index;
